(function () {
	'use strict';

	angular
		.module('wizard-english-test.services')
		.service('AgeGroupsService', AgeGroupsService)

	/** @ngInject */
	function AgeGroupsService(HttpService) {
		const AgeGroupsService = {
			getAgeGoups
		};

		return AgeGroupsService;

		function getAgeGoups() {
			return HttpService.get('/age-groups');
		}
	}
}());